import type { FC, ReactNode } from 'react'
import type { ClientLogo } from '@/types'

import { cn } from '@/lib/utils'
import { Marquee } from '@/components/motion/marquee'

interface ClientStripProps {
    clients: ClientLogo[]
    label?: string
    aside?: string
    className?: string
    invert?: boolean
}

// Endless band of client logos that reacts to scroll speed and direction.
export const ClientStrip: FC<ClientStripProps> = ({ clients, label = 'Selected clients', aside, className, invert = false }): ReactNode => {
    return (
        <div className={cn('border-y border-tone-line py-10 md:py-12', className)}>
            <div className='mb-6 flex items-center justify-between gap-6 px-5 t-label text-tone-muted md:px-8 lg:px-12'>
                <span>
                    {label}
                </span>
                {aside && (
                    <span className='hidden sm:block'>
                        {aside}
                    </span>
                )}
            </div>

            <Marquee speed={1.4}>
                {clients.map(client => (
                    <span key={client.name} className='flex h-16 w-40 shrink-0 items-center justify-center px-4 md:h-20 md:w-52'>
                        <img
                            src={client.src}
                            alt={`${client.name} logo`}
                            width={400}
                            height={187}
                            loading='lazy'
                            className={cn('h-full w-full object-contain opacity-60 transition-opacity duration-500 hover:opacity-100', invert && 'invert')}
                        />
                    </span>
                ))}
            </Marquee>
        </div>
    )
}
